<div class="login-bg">
	<div class="login-page">
		<div class="login-form">
			<form [formGroup]="formGroup" (ngSubmit)="reset()">
				<img
					src="https://i.ibb.co/XW8Kpnz/mockup-2-1.png"
					alt=""
					class="mobile-img"
				/>
				<div class="form-field" *ngIf="!success">
					<div class="forgot-pass-container">
						<img
							src="https://i.ibb.co/yW9d0nh/forgot-password-icon-1.png"
							class="logo"
							alt=""
						/>
						<div class="title">{{ "auth.forgotPassTitle" | translate }}</div>
						<div class="desc">{{ "auth.forgotPassDesc" | translate }}</div>

						<div class="forgot-pass">
							<mat-form-field appearance="outline">
								<mat-label>{{ "auth.yourEmail" | translate }}</mat-label>
								<input
									class="uppercase"
									matInput
									required
									formControlName="email"
									type="email"
								/>
								<mat-error>{{ "error.emailRequired" | translate }}</mat-error>
							</mat-form-field>

							<button
								mat-raised-button
								color="primary"
								class="forgot-pass-btn mt-sm primary"
								[disabled]="formGroup.invalid"
							>
								{{ "auth.resetPass" | translate }}
							</button>

							<div class="forgot-password-link">
								<div>
									{{ "auth.alreadyHaveAcc" | translate }}
									<span
										(click)="goToLogin()"
										>{{ "auth.login" | translate }}</span
									>
								</div>
								<section style="opacity: 0">1</section>
							</div>
						</div>
					</div>
				</div>
			</form>
			<mat-card class="form-field" *ngIf="success">
				<img
					src="assets/image/check-email-graphic.png"
					class="check-email-img"
					alt=""
				/>
				<div class="check-email-text">{{ "auth.checkYourEmail" | translate }}</div>

				<mat-card-content>
					<p style="text-align: center">
						{{ "auth.emailSent" | translate }}
						<button
							mat-raised-button
							color="primary"
							class="lg"
							(click)="goToLogin()"
						>
							{{ "auth.login" | translate }}
						</button>
					</p>
				</mat-card-content>
			</mat-card>
		</div>
		<div class="crm-info">
			<img
				src="{{ bannerLink }}"
				alt="mockup-1"
			/>
		</div>
	</div>
</div>
